import React, { useState, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useOnClickOutside } from "../../hooks";
import Link from "gatsby-plugin-transition-link";
import { GatsbyImage } from "gatsby-plugin-image";
import tw from "twin.macro";
import styled from "@emotion/styled";
import Banner from "../Faqs/Banner";

import Burger from "./Burger";
import OffCanvas from "./OffCanvas";
import ButtonSolid from "../Button/ButtonSolid";
import ButtonGhost from "../Button/ButtonGhost";
// import ButtonGhost from "../Button/ButtonGhost";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemButton,
//   AccordionItemState,
//   AccordionItemPanel,
// } from "react-accessible-accordion";
// import phone from "../../images/Global/phone.png";
const StyledContent = styled.div`
  ul {
    ${tw`absolute top-0 z-10 -translate-x-5 transform flex-col space-y-2.5 border-t-2 border-primary-500 bg-white px-6 py-5 shadow-xl transition-all duration-300 ease-linear`}
  }
  li {
    width: 100%;
  }
  ol {
    ${tw`list-decimal pl-7 mb-6 flex flex-col space-y-0.5`}
  }

  a:not(.font-body font-normal),
  span {
    ${tw`relative font-medium text-[16px] leading-[24px] w-full transition-[color] duration-300 ease-linear  text-[#191919]hover:text-primary-500 no-underline  after:absolute after:left-auto after:right-0 after:-bottom-1 after:h-[.050rem] after:w-0 after:bg-tertiary-400 after:transition-all after:duration-300 after:ease-linear hover:after:left-0 hover:after:right-auto hover:after:w-full`}
  }
  li:has(a) span{
    ${tw`relative  w-full transition-[color] duration-300 ease-linear  text-primary-500 hover:text-primary-400 no-underline  after:absolute after:left-auto after:right-0 after:-bottom-1 after:h-[.050rem] after:w-0 after:bg-tertiary-400 after:transition-all after:duration-300 after:ease-linear hover:after:left-0 hover:after:right-auto hover:after:w-full`}
  }
`;
const MainNav = ({ navigationStyle, scrolled, offcanvasOffset }) => {
  // determine if offcanvas is open
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  const [subMenuHovering1, setSubMenuHovering1] = useState(false);
  const isHoveringSubMenu1 = () => setSubMenuHovering1(true);
  const notHoveringSubMenu1 = () => setSubMenuHovering1(false);

  const [subMenuHovering2, setSubMenuHovering2] = useState(false);
  const isHoveringSubMenu2 = () => setSubMenuHovering2(true);
  const notHoveringSubMenu2 = () => setSubMenuHovering2(false);

  // handle click of navigation items
  const clickHandler = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };
  const clickHandler_disabled = () => {
    // setOffcanvasOpen(!offcanvasOpen);
  };

  // close offcanvas onclick outside
  const node = useRef();
  useOnClickOutside(node, () => setOffcanvasOpen(false));

  const data = useStaticQuery(graphql`
    {
      darkLogo: file(relativePath: { eq: "Global/Logo/logo-color.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, width: 125)
        }
      }
      lightLogo: file(relativePath: { eq: "Global/Logo/logo-color.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, width: 270)
        }
      }
    }
  `);

  // Define logos based on header style
  let logo = null;

  if (navigationStyle === "overlap") {
    logo = data.lightLogo.childImageSharp.gatsbyImageData;
  } else {
    logo = data.darkLogo.childImageSharp.gatsbyImageData;
  }

  if (scrolled) {
    logo = data.darkLogo.childImageSharp.gatsbyImageData;
  }

  if (offcanvasOpen) {
    logo = data.darkLogo.childImageSharp.gatsbyImageData;
  }

  const navigation = {
    services: [
      {
        name: "Assisted Living",
        href: "/point-loma-assisted-living/",
      },
      {
        name: "Alzheimer’s Care",
        href: "/alzheimers-care/",
      },
      {
        name: "Dementia Care",
        href: "/dementia-services/",
      },
      {
        name: "Hospice Care",
        href: "/hospice-assisted-living/",
      },
      {
        name: "Respite Care",
        href: "/respite-care-services/",
      },
      {
        name: "Enriching Experiences",
        href: "/senior-living/",
      },
    ],
    about: [
      {
        name: "About Us",
        href: "/about/",
      },
      {
        name: "Amenities",
        href: "/amenities/",
      },
      {
        name: "Neighborhood",
        href: "/neighborhood/",
      },

    ],
  };

  return (
    <nav
      id="main-navigation"
      className={`w-full py-2 transition duration-300 ease-linear ${
        navigationStyle === "overlap"
          ? "absolute lg:bg-transparent"
          : "lg:bg-white"
      } ${offcanvasOpen && "!bg-white"} ${
        scrolled && "!fixed top-0 left-0 z-50 w-full !bg-white !shadow-4xl"
      } `}
      role="navigation"
      aria-label="main-navigation"
    >
      <div className="container flex items-center justify-between">
        <div className="flex flex-auto items-center lg:hidden">
          <a className="" href="tel:(619) 225-5616">
            {/* <img src={phone} width={32} /> */}
            <i className="fas fa-phone"></i>
          </a>
        </div>
        <div className="flex flex-auto items-center justify-center lg:justify-start ">
          <Link to="/">
            <GatsbyImage
              image={logo}
              alt="BayView Logo"
              placeholder="none"
              objectFit="contain"

            />
          </Link>
        </div>

        <div className="flex flex-auto items-center justify-end">
          <ul
            id="navigation-desktop"
            className="hidden lg:ml-6 lg:mr-10 lg:flex lg:flex-row lg:items-center lg:justify-end lg:space-x-5 xl:space-x-8"
          >
            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu1}
              onMouseLeave={notHoveringSubMenu1}
            >
              <Link
                to="/senior-care-services/"
                className={`relative inline  h-full  text-[16px] leading-[24px]  no-underline transition-all duration-300 ease-linear  ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-primary-500"
                } ${subMenuHovering1 && "!text-primary-500"}  ${
                  scrolled && "text-gray-900 hover:text-primary-500"
                }`}
              >
                <StyledContent className="">
                  <span className="font-w-hover">Programs</span>
                </StyledContent>
              </Link>
              <div
                className={`absolute !bg-transparent ${
                  subMenuHovering1
                    ? "visible translate-y-0 opacity-100 transition-all duration-300 ease-linear"
                    : "invisible translate-y-20 opacity-0 transition-all duration-300 ease-linear"
                }`}
              >
                <ul
                  className={` relative z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-xl bg-white px-6 py-5 shadow-xl transition-all duration-300 ease-linear ${
                    subMenuHovering1
                      ? "visible translate-y-[45px] opacity-100 transition-all duration-300 ease-linear"
                      : "invisible translate-y-20 opacity-0 transition-all duration-300 ease-linear"
                  }`}
                >
                  {navigation.services.map((item, i) => {
                    return (
                      <StyledContent>
                        <li key={i} className="whitespace-nowrap">
                          {" "}
                          <Link to={item.href}>
                            <span className="font-w-hover">{item.name}</span>
                          </Link>
                        </li>
                      </StyledContent>
                    );
                  })}
                </ul>
              </div>
            </li>

            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu2}
              onMouseLeave={notHoveringSubMenu2}
            >
              <Link
                to="/about/"
                className={`relative inline text-[15px] font-normal no-underline transition-all duration-300 ease-linear  ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-primary-500"
                } ${subMenuHovering2 && "!text-primary-500"}  ${
                  scrolled && "text-gray-900 hover:text-primary-400"
                }`}
              >
                <StyledContent className="">
                  <span className="font-w-hover">About</span>
                </StyledContent>
              </Link>
              <div
                className={`absolute !bg-transparent ${
                  subMenuHovering2
                    ? "visible translate-y-0 opacity-100 transition-all duration-300 ease-linear"
                    : "invisible translate-y-20 opacity-0 transition-all duration-300 ease-linear"
                }`}
              >
                <ul
                  className={` relative z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-xl bg-white px-6 py-5 shadow-xl transition-all duration-300 ease-linear ${
                    subMenuHovering2
                      ? "visible translate-y-[45px] opacity-100 transition-all duration-300 ease-linear"
                      : "invisible translate-y-20 opacity-0 transition-all duration-300 ease-linear"
                  }`}
                >
                  {navigation.about.map((item, i) => {
                    return (
                      <StyledContent>
                        <li key={i} className="whitespace-nowrap">
                          {" "}
                          <Link to={item.href}>
                            <span className="font-w-hover">{item.name}</span>
                          </Link>
                        </li>
                      </StyledContent>
                    );
                  })}
                </ul>
              </div>
            </li>

            <li>
              <Link
                to="/reviews/"
                className={`relative inline overflow-hidden font-body font-normal no-underline transition-all duration-300 ease-linear ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "hover:text-primary-800 text-gray-900"
                } ${scrolled && "hover:text-primary-800 text-gray-900"}`}
              >
                <StyledContent className="">
                  <span className="font-w-hover">Reviews</span>
                </StyledContent>
              </Link>
            </li>

            <li>
              <Link
                to="/assisted-living-blog/"
                className={`relative inline overflow-hidden font-body font-normal no-underline transition-all duration-300 ease-linear ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-primary-500"
                } ${scrolled && "text-gray-900 hover:text-primary-500"}`}
              >
                <StyledContent className="">
                  <span className="font-w-hover">Blog</span>
                </StyledContent>
              </Link>
            </li>
          </ul>

          <div className="hidden items-center space-x-4 lg:inline-flex">
            <ButtonSolid modal="modal-contact" text="Contact" />
          </div>

          <div className="lg:hidden" ref={node}>
            {/* Burger */}
            <Burger
              offcanvasOpen={offcanvasOpen}
              setOffcanvasOpen={setOffcanvasOpen}
              navigationStyle={navigationStyle}
              scrolled={scrolled}
              aria-controls="offcanvas-navigation"
            />

            {/* Mobile Nav */}
            <OffCanvas
              offcanvasOpen={offcanvasOpen}
              offcanvasOffset={offcanvasOffset}
              id="offcanvas-navigation"
            >
              {/* off canvas menu */}
              <div className="relative h-full bg-secondary-400 px-6 pt-16 pb-26">
                <ul
                  id="navigation-mobile"
                  className="mb-20 space-y-6 bg-secondary-400 px-6 text-center"
                >
                  <li>
                    <Banner>
                      <Banner.EntityNav>
                        <Banner.NavMenu>Programs</Banner.NavMenu>
                        <ul className="space-y-4 pt-1.5">
                          {navigation.services.map((item, i) => {
                            return (
                              <Banner.NavItem
                                name={item.name}
                                href={item.href}
                              ></Banner.NavItem>
                            );
                          })}
                          {/* <Banner.NavItem
                            name="All Programs"
                            href="/"
                          ></Banner.NavItem> */}
                        </ul>
                      </Banner.EntityNav>
                    </Banner>
                  </li>
                  <li>
                    <Banner>
                      <Banner.EntityNav>
                        <Banner.NavMenu>About</Banner.NavMenu>
                        <ul className="space-y-4 pt-1.5">
                          {navigation.about.map((item, i) => {
                            return (
                              <Banner.NavItem
                                name={item.name}
                                href={item.href}
                              ></Banner.NavItem>
                            );
                          })}
                        </ul>
                      </Banner.EntityNav>
                    </Banner>
                  </li>
                  <li>
                    <Link
                      to="/reviews/"
                      onClick={clickHandler}
                      className="mb-16 font-heading text-[34px] font-bold leading-[2.125rem] text-primary-400 no-underline transition-colors duration-300 ease-linear hover:text-primary-500"
                    >
                      Reviews
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/assisted-living-blog/"
                      onClick={clickHandler}
                      className="mb-16 font-heading text-[34px] font-bold leading-[2.125rem] text-primary-400 no-underline transition-colors duration-300 ease-linear hover:text-primary-500"
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <button
                      data-modal-open="modal-contact"
                      onClick={clickHandler_disabled}
                      className="font-heading text-[34px] font-bold leading-[2.125rem] text-primary-400 no-underline hover:text-primary-500"
                    >
                      Contact
                    </button>
                  </li>
                  <li className="pt-[25px] lg:hidden">
                    <div className="mx-auto grid w-full max-w-[254px] grid-cols-1 gap-y-4">
                      <div>
                        <ButtonGhost
                          href="tel:(619) 225-5616"
                          text="(619) 225-5616"
                        />
                      </div>
                      <div>
                        <ButtonSolid modal="modal-contact" text="Contact Us" />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </OffCanvas>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default MainNav;
